import { SET_MESSAGE } from "../types";

export const setMessage = (data) => {
  return {
    type: SET_MESSAGE,
    payload: data,
  };
};
